module.exports = __webpack_public_path__ + "static/media/moreGames.8915353c.png";